import { render } from "./RiSortDown.vue?vue&type=template&id=7794882d"
import script from "./RiSortDown.vue?vue&type=script&lang=js"
export * from "./RiSortDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiSortDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7794882d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7794882d', __exports__)) {
    api.reload('7794882d', __exports__)
  }
  
  module.hot.accept("./RiSortDown.vue?vue&type=template&id=7794882d", () => {
    api.rerender('7794882d', render)
  })

}


export default __exports__